﻿import React from "react";
import { GeneralPrivacyPolicyEN } from "./GeneralPrivacyPolicyEN";
import { GeneralPrivacyPolicyIT } from "./GeneralPrivacyPolicyIT";
import { GeneralPrivacyPolicyES } from "./GeneralPrivacyPolicyES";
import { GeneralPrivacyPolicyPTBR } from "./GeneralPrivacyPolicyPTBR";
import { GeneralPrivacyPolicyDE } from "./GeneralPrivacyPolicyDE";
import { GeneralPrivacyPolicyFR } from "./GeneralPrivacyPolicyFR";
import { GeneralPrivacyPolicyNL } from "./GeneralPrivacyPolicyNL";
import { injectFromAppLegal } from "../../inject";
import type { IResourcesStore } from "../../../resources/ResourcesStore";

interface IGeneralPrivacyPolicyComponentProps {
    resourcesStore?: IResourcesStore;
}

@injectFromAppLegal<IGeneralPrivacyPolicyComponentProps>(stores => ({
    resourcesStore: stores.resourcesStore,
}))
export class GeneralPrivacyPolicyComponent extends React.Component<IGeneralPrivacyPolicyComponentProps> {
    render() {
        const { resourcesStore } = this.props;
        const { currentLanguage } = resourcesStore!;

        switch (currentLanguage) {
            case "nl":
                return <GeneralPrivacyPolicyNL />;
            case "fr":
                return <GeneralPrivacyPolicyFR />;
            case "de":
                return <GeneralPrivacyPolicyDE />;
            case "pt-br":
                return <GeneralPrivacyPolicyPTBR />;
            case "es":
                return <GeneralPrivacyPolicyES />;
            case "it":
                return <GeneralPrivacyPolicyIT />;
            case "en":
            case "no":
            default:
                return <GeneralPrivacyPolicyEN />;
        }
    }
}
